import { render, staticRenderFns } from "./CentroOncologiaComponente.vue?vue&type=template&id=50cce35c&scoped=true"
import script from "./CentroOncologiaComponente.vue?vue&type=script&lang=js"
export * from "./CentroOncologiaComponente.vue?vue&type=script&lang=js"
import style0 from "./CentroOncologiaComponente.vue?vue&type=style&index=0&id=50cce35c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50cce35c",
  null
  
)

export default component.exports